export default [
    {
        value: {
            value: 'admin.natura',
            id: 'admin.natura'
        },
        label: 'Administrador',
    }, {
        value: {
            value: 'operador.natura',
            id: 'operador.natura'
        },
        label: 'Operador',
    }
];
